
































































import { Component, Vue } from "vue-property-decorator";
import TimeEntryFilterComponent from "@/components/timeentry-filter/TimeEntryFilterComponent.vue";
import {
  ProjectFixedPriceRevenueFteModel,
  ProjectFixedPriceRevenueFteQuery,
  ProjectFixedPriceUserOverviewModel,
  ProjectFixedPriceUserOverviewQuery,
  TimeEntryFilter,
  TimeEntryFilterTimeFrame
} from "@/services/api/nswag/stapiclient_generated";
import { FilterControl } from "@/components/timeentry-filter/filterControl";
import StProgress from "@/components/basic/StProgress.vue";
import { stProjectFixedPriceReportApi } from "@/services/st-api";

@Component({
  components: {
    StProgress,
    TimeEntryFilterComponent
  }
})
export default class FixedPriceProjectReports extends Vue {
  filter: TimeEntryFilter = TimeEntryFilter.fromJS({
    timeframe: TimeEntryFilterTimeFrame.ThisYear
  });

  revenueFteData: ProjectFixedPriceRevenueFteModel[] = [];
  userOverviewData: ProjectFixedPriceUserOverviewModel[] = [];

  loading = false;

  get filterControl() {
    return { showOnlyDate: true } as FilterControl;
  }

  async mounted(){
    await this.loadData();
  }

  async loadData() {
    this.revenueFteData = await stProjectFixedPriceReportApi.getRevenueFteReport(ProjectFixedPriceRevenueFteQuery.fromJS({}));
    this.userOverviewData = await stProjectFixedPriceReportApi.getUserOverviewReport(ProjectFixedPriceUserOverviewQuery.fromJS({}));
  }

  async applyFilter() {
    await this.loadData();
  }

  get revenueFteChartOptions() {
    return {
      series: [
        {
          name: 'durchschnittl. Umsatz',
          type: 'bar',
          data: this.revenueFteData.map((entry) => entry.avgRevenueFte),
        },
        {
          name: 'durchschnittl. Umsatz (inkl. offene Projekte)',
          type: 'bar',
          data: this.revenueFteData.map((entry) => entry.avgRevenueFteInclNotFinished),
        },
      ],
      chartOptions: {
        chart: {
          height: 350
        },
        colors: ['#2980b9', '#5cb85c'],
        plotOptions: {
          bar: {
            endingShapes: 'round',
            columnWidth: '50px',
          },
        },
        stroke: {
          width: [0, 3],
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.revenueFteData.map((entry) => {
          return this.$options.filters?.formatQuarter(entry.date);
        }),
        xaxis: {
          type: 'string',
        },
        yaxis: [
          {
            title: {
              text: this.$t('Umsatz').toString(),
            },
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          }
        ],
      },
    }
  };
}
